import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { VideoRecordComponent } from './video-record/video-record.component';
import { VideoRecordModalComponent } from './video-record-modal.component';
import { FaceFilterRaccoonComponent } from '../face-filter/face-filter-raccoon/face-filter-raccoon.component';
import { FaceFilterTessellationComponent } from '../face-filter/face-filter-tessellation/face-filter-tessellation.component';

@NgModule({
  imports: [CommonModule, UiModule, TrackingModule],
  declarations: [
    VideoRecordModalComponent,
    VideoRecordComponent,
    FaceFilterRaccoonComponent,
    FaceFilterTessellationComponent,
  ],
  exports: [VideoRecordModalComponent],
})
export class VideoRecordModalModule {}
